module.exports = __webpack_public_path__ + "static/media/cloud-hail-mixed.37ef42fe.svg";